import { ProgressBar } from 'primereact/progressbar';

export function ProgressBarComponent() {
  return (
    <div className="text-center py-6">
      <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
    </div>
  );
}
